/**
 * MovingItemRequest[] → ItemPickerInstance[] 변환.
 *
 * 기존 짐 기록 데이터(MovingItemRequest)를 InquiryFlow item-picker 의 initialValues
 * 형태(`ItemPickerInstance[]`)로 prefill 하기 위한 어댑터.
 *
 * spec 의 attribute 키 → `attr__${key}` 으로 prefix 하고, `serviceSet` 도 포함한다.
 */
import type { ItemPickerInstance } from '@miso/design-system';
import type {
  MovingItemRequest,
  ServiceSet,
} from '@/entities/visit-counsel/model/room-observing.types';

const ATTR_PREFIX = 'attr__';

export function movingItemsToInstances(items: MovingItemRequest[]): ItemPickerInstance[] {
  return items.map((item, idx) => {
    const answers: Record<string, unknown> = {
      serviceSet: item.serviceSet as ServiceSet,
    };
    for (const [k, v] of Object.entries(item.attributes ?? {})) {
      if (v !== null && v !== undefined && v !== '') {
        answers[`${ATTR_PREFIX}${k}`] = v;
      }
    }
    return {
      instanceId: `prefill_${item.specId}_${idx}_${Date.now()}`,
      itemId: item.specId,
      answers,
    };
  });
}
